import { DropdownItem } from 'reactstrap';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'src/store/store';
import { setAlert } from 'src/components/alert/actions';
import { showRestrictMemberModal, showUnrestrictMemberModal } from 'src/modules/community/shared/actions';
import { removeMemberFromCommunity } from 'src/api/community';
import i18n from 'src/utils/translate';
import { getCanEditBadgesAndRestrict, userHasRole } from 'src/utils/context';
import { useModalTrigger } from 'src/utils/hooks';
import ButtonDropdown from 'src/components/buttons/buttonDropdown';
import { CommunityMember, Role } from 'src/constants/types';
import { ModalType } from 'src/constants/modalTypes';
export default function CommunityMemberCardMenu({
  member
}: {
  member: CommunityMember;
}) {
  const dispatch = useDispatch();
  const {
    pathname,
    query
  } = useRouter();
  const communitySlug = useSelector(({
    context
  }) => context.currentCommunity?.slug) ?? '';
  const currentUser = useSelector(({
    context
  }) => context.currentUser);
  const triggerRemoveMemberModal = useModalTrigger(ModalType.CommunityRemoveMember, {
    username: member.username,
    onAccept: () => removeMember()
  });
  const removeMember = async () => {
    const {
      data,
      status
    } = await removeMemberFromCommunity(communitySlug, member.userId);
    if (status === 200) {
      dispatch(setAlert(i18n.t(`You removed ${member.username} from this community`), 'success'));
    } else {
      const message = data && data.message || i18n.t('There was a problem. Please refresh the page and try again.');
      dispatch(setAlert(message));
    }
  };
  const triggerEditBadgesModal = useModalTrigger(ModalType.EditBadges, {
    member
  });
  const canRemove = userHasRole(currentUser, Role.HealthUnlocked);
  const canEditBadgesAndRestrict = getCanEditBadgesAndRestrict(currentUser?.roles, member?.roles);
  const isRestrictedMembersPage = pathname === '/[communitySlug]/members' && query.filter === 'restricted';
  if (!canRemove && !canEditBadgesAndRestrict) return null;
  return <StyledButtonDropdown ariaLabel="Options" color="none" isRightAligned={true} data-sentry-element="StyledButtonDropdown" data-sentry-component="CommunityMemberCardMenu" data-sentry-source-file="communityMemberCardMenu.tsx">
      {canRemove && <DropdownItem onClick={triggerRemoveMemberModal}>
          {i18n.t('Remove')}
        </DropdownItem>}
      {canEditBadgesAndRestrict && <DropdownItem onClick={triggerEditBadgesModal}>
          {i18n.t('Edit badges')}
        </DropdownItem>}
      {canEditBadgesAndRestrict && !isRestrictedMembersPage && <DropdownItem onClick={() => dispatch(showRestrictMemberModal(member.userId, member.username, communitySlug))}>
          {i18n.t('Restrict')}
        </DropdownItem>}
      {canEditBadgesAndRestrict && isRestrictedMembersPage && <DropdownItem onClick={() => dispatch(showUnrestrictMemberModal(member.userId, member.username, communitySlug))}>
          {i18n.t('Unrestrict')}
        </DropdownItem>}
    </StyledButtonDropdown>;
}
const StyledButtonDropdown = styled(ButtonDropdown)`
  .dropdown-toggle {
    padding-left: 4px;
    padding-right: 10px;
  }
  .dropdown-toggle::after {
    content: '\\e8d5'; // icon-cog
  }
`;